module.exports = "https://www.gc-pro.gnp.com.mx/3498c81ac7990dc2c0915b9a209168e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circlie-dove.svg
// module id = 8088
// module chunks = 0